import React from 'react';
import { Button } from './ui/button';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-headline">PRECISION AS STANDARD.</h1>
          <p className="hero-subtext">
            A modern barber studio built on discipline, intent, and craft.
          </p>
          <div className="hero-actions">
            <Button 
              className="hero-button-primary"
              onClick={() => window.open('https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/all-offer?share=true&pId=1274239', '_blank')}
            >
              BOOK YOUR VISIT
            </Button>
            <button 
              className="hero-button-secondary"
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              VIEW SERVICES
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;